import ABCyaPhaser from "@abcya/abcya_phaser";
import { LightClickHandler, onBlinkButtonHandler, onSolidButtonHandler } from "./TrayItemsClickedActions/LightClickHandler.js";
import {TraySpacer} from "./TrayPlacementTools.js"

export function LightTab(Scene,Tray)
{
    var LightsList = [];
    var CurrentBackDrop = "";
    var BlinkOrSolidButtonBackDrop = Scene.addImage(161, 26, "Lt_Rd").setAngle(-90);
    const DepthList = Scene.DepthList;
    const SelectionBackDrop = Scene.add.group();

    const LightPlacementX = TraySpacer(Tray,6,24,8);
    const LightPlacementY = [];
    const IntialHeight = 58;
    const LightBulbHeight = 41;
    const RowSpacing = 12;
    const TrayArray = [];

    const SolidBulb = Scene.addImage(160 - 210, 26, "Lt_Rd").setAngle(-90);
    const BlinkBulb = Scene.addImage(260 - 210, 26, "Lt_Rd").setAngle(-90);

    const Solid = Scene.add.text(185 - 210,16,ABCyaPhaser.Localization.instance.getLocalizedString("lights_menu.solid"),{fontFamily: 'fulbotano',color: 0x045613, fontSize: 16});
    const Blink = Scene.add.text(285 - 210,16,ABCyaPhaser.Localization.instance.getLocalizedString("lights_menu.blink"),{fontFamily: 'fulbotano',color: 0x045613, fontSize: 16});
    ABCyaPhaser.Text.resizeFontToFitWidth(Solid, 48);
    ABCyaPhaser.Text.resizeFontToFitWidth(Blink, 48);

    //const BlinkEffect = Scene.addImage(BlinkBulb.x,BlinkBulb.y,"Lt_Glow").setDepth(DepthList.OrnBack);
    //BlinkEffect.setTint(0xF70D0D);

    const BlinkEffect = Scene.addImage(BlinkBulb.x,BlinkBulb.y,"LtSlct_Glow").setDepth(DepthList.OrnBack);

    //const BlinkTween = Scene.addTween(BlinkEffect,10,{alpha:0,yoyo:true,delay:400,hold:800,repeat:-1,repeatDelay:800});

    const HeaderArray = [SolidBulb,BlinkBulb,Solid,Blink];

    BlinkOrSolidButtonBackDrop.setTint(0x000000);
    BlinkOrSolidButtonBackDrop.setScale(1.2);
    BlinkOrSolidButtonBackDrop.setDepth(DepthList.OrnMiddle);

    if(Scene.LightsBlinking)
    {
        BlinkOrSolidButtonBackDrop.x = BlinkBulb.x;
        BlinkOrSolidButtonBackDrop.y = BlinkBulb.y;
        BlinkEffect.setPosition(BlinkBulb.x,BlinkBulb.y);
        Scene.LightGroup.add(BlinkEffect);
        //console.log(Scene.LightGroup);
        //BlinkTween.restart();
    }
    else
    {
        BlinkOrSolidButtonBackDrop.x = SolidBulb.x;
        BlinkOrSolidButtonBackDrop.y = SolidBulb.y;
        BlinkEffect.setPosition(SolidBulb.x,SolidBulb.y);
        //BlinkTween.pause();
        BlinkEffect.setAlpha(1);
    }
    
    for(let inHeader in HeaderArray)
    {
        TrayArray.push(HeaderArray[inHeader]);
        HeaderArray[inHeader].setInteractive();

        if(parseInt(inHeader) % 2)
        {
            HeaderArray[inHeader].on('pointerdown',()=>{
                //console.log("On");
                //onBlinkButtonHandler(Scene,BlinkOrSolidButtonBackDrop,BlinkBulb,BlinkEffect,BlinkTween);
                onBlinkButtonHandler(Scene,BlinkOrSolidButtonBackDrop,BlinkBulb,BlinkEffect);
            });
        }
        else
        {
            HeaderArray[inHeader].on('pointerdown',()=>{
                //onSolidButtonHandler(Scene,BlinkOrSolidButtonBackDrop,SolidBulb,BlinkEffect,BlinkTween);
                onSolidButtonHandler(Scene,BlinkOrSolidButtonBackDrop,SolidBulb,BlinkEffect);
            });
        }
        HeaderArray[inHeader].setDepth(DepthList.OrnMiddle);
    }
    
    TrayArray.push(BlinkOrSolidButtonBackDrop);
    TrayArray.push(BlinkEffect);
    TrayArray.push(Scene.addImage(234 - 210,55,"Line").setDepth(DepthList.OrnBack));

    const LightColorArray = [
        ["Lt_Grn"],
        ["Lt_Aqua"],
        ["Lt_Blue"],
        ["Lt_Prpl"],
        ["Lt_Pnk"],
        ["Lt_Rd"],
        ["Lt_Orng"],
        ["Lt_Ylw"],
        ["Lt_Wt"],
        ["Lt_Grn","Lt_Aqua","Lt_Prpl","Lt_Rd","Lt_Orng","Lt_Ylw"],
        ["Lt_Rd","Lt_Grn"],
        ["Lt_Pnk","Lt_Prpl"],
        ["Lt_Aqua","Lt_Blue"]
    ];
    
    for (let x = 0; x < 13; x++)
    {
        if (x === 0)
        {
            LightPlacementY[x] = IntialHeight + (LightBulbHeight*.5) + RowSpacing;
        }
        else
        {
            LightPlacementY[x] = LightPlacementY[x-1] + LightBulbHeight + RowSpacing;
        } 
    }
    //console.log(LightPlacementY);

    for (let y in LightPlacementY)
    {
        LightsList[y]=[];
        switch(LightColorArray[y].length)
        {
            case 1:
                for (let x in LightPlacementX)
                {
                    LightsList[y][x] = Scene.addImage(LightPlacementX[x],LightPlacementY[y],LightColorArray[y]);
                    TrayArray.push(LightsList[y][x]);
                }
            break;

            case 2:
                for (let x in LightPlacementX)
                {
                    let ColorDecider = x % 2;
                    LightsList[y][x] = Scene.addImage(LightPlacementX[x],LightPlacementY[y],LightColorArray[y][ColorDecider]);
                    TrayArray.push(LightsList[y][x]);
                }
            break;

            case 6:
                for (let x in LightPlacementX)
                {
                    LightsList[y][x] = Scene.addImage(LightPlacementX[x],LightPlacementY[y],LightColorArray[x]);
                    TrayArray.push(LightsList[y][x]);
                }
                break;
                
            default:
                //console.log(LightColorArray[y].length + "Is not a switch option");
                break;
        }
    }

    for(let Row in LightsList)
    {
        for(let InRow in LightsList[Row])
        {
            if(InRow === '0')
            {
                //console.log("wut");

                LightsList[Row][InRow].setInteractive();
                ////console.log(LightsList[Row][InRow]);
                LightsList[Row][InRow].input.hitArea.setTo(0,0,184,40);
            }
            else
            {
                LightsList[Row][InRow].setInteractive();
            }
            LightsList[Row][InRow].setDepth(DepthList.OrnMiddle);
            LightsList[Row][InRow].on('pointerdown',function()
            {
                BackDropSetUp(LightsList[Row],Row);
            });
        }
    }

    Scene.TrayGroup.addMultiple(TrayArray);
    //Scene.TrayGroup.clear(true,true);

    function BackDropSetUp(Row,RowName)
    {
        if (CurrentBackDrop != RowName)
        {
            Scene.AudioChan.Chan5.play('click_in_game');
            CurrentBackDrop = RowName;
            SelectionBackDrop.clear(true,true);
            for(let InRow in Row)
            {
                let BackDrop = Scene.addImage(Row[InRow].x,Row[InRow].y,Row[InRow].frame.name);
                BackDrop.setScale(Row[InRow].scale + .2);
                BackDrop.setTint(0x000000);
                BackDrop.setDepth(DepthList.OrnBack);
                SelectionBackDrop.add(BackDrop);
            }

            SelectionBackDrop.getChildren().forEach(element =>
                {
                    Scene.TrayGroup.add(element);
                    element.setDepth(DepthList.OrnBack);
                });
        }
        LightClickHandler(Row,RowName); 
    }
}